import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {},
      styleOverrides: {
        select: {
          padding: '10px 16px',
          fontWeight: 600,
          minWidth: '124px',
        },
        root: {
          borderRadius: '6px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
          },
        },
      },
    },
  }
}
